import { readAppValue } from "../config/runtimeAccessor";

export const getLocalStorageItem = (key) => readAppValue(key);
